import { getContentfulAssetUrlandAlt } from 'common/components';
import getContentfulField from 'common/components/Contentful/getContentfulField';
import { DateTime } from 'luxon';
import { formatStartAndEndDate } from 'utils/helpers';

export const DEFAULT_MAINTENANCE_REASON = 'Scheduled Maintenance';
export const TEMPORARILY_CLOSED_REASON = 'Temporarily Closed';
export const getContentRides = (venue) => {
  if (!venue.content) return;

  if (!venue.content.rideCards) return;

  const rides = getContentfulField(venue.content.rideCards);

  return rides.map((ride) => ({
    name: ride.fields.name && getContentfulField(ride.fields.name),
    category: ride.fields.category && getContentfulField(ride.fields.category),
    description: ride.fields.description,
    image: ride.fields.image && getContentfulAssetUrlandAlt(ride.fields.image),
    schedule:
      ride.fields.schedule &&
      parseRideSchedule(getContentfulField(ride.fields.schedule)),
  }));
};

export const parseRideSchedule = (rideSchedule) => {
  const isTemporarilyClosed = rideSchedule.fields.temporarilyClosed
    ? getContentfulField(rideSchedule.fields.temporarilyClosed)
    : false;

  const closedDates = !rideSchedule.fields.closedDates
    ? []
    : getContentfulField(rideSchedule.fields.closedDates).map((closedDate) => ({
        name:
          closedDate.fields.name && getContentfulField(closedDate.fields.name),
        startDate:
          closedDate.fields.startDate &&
          getContentfulField(closedDate.fields.startDate),
        endDate:
          closedDate.fields.endDate &&
          getContentfulField(closedDate.fields.endDate),
        reason:
          closedDate.fields.reason &&
          getContentfulField(
            getContentfulField(closedDate.fields.reason).fields.value
          ),
      }));

  return {
    isTemporarilyClosed,
    closedDates,
  };
};
export function parseRideMaintenanceSchedule(rides) {
  return (rides || [])
    .filter((card) => card.schedule)
    .reduce((acc, card) => {
      const now = DateTime.local();

      const closedDates = [
        ...card.schedule.closedDates.filter(({ endDate }) => now <= endDate),
        ...(card.schedule.temporarilyClosed
          ? [{ reason: TEMPORARILY_CLOSED_REASON }]
          : []),
      ];

      for (const dates of closedDates) {
        const isClosedNow = !dates.startDate || now >= dates.startDate;

        const label = isClosedNow
          ? 'Closed now'
          : formatStartAndEndDate(dates.startDate, dates.endDate);

        const item = {
          image: card.image,
          name: card.name,
          reason: `${dates.reason}${
            now >= dates.startDate
              ? ` (${formatStartAndEndDate(dates.startDate, dates.endDate)})`
              : ''
          }`,
          startDate: dates.startDate,
          endDate: dates.endDate,
        };

        const existing = acc.find((item) => item.label === label);
        if (existing) {
          existing.items.push(item);
        } else {
          acc.push({
            label,
            startDate: dates.startDate,
            items: [item],
          });
        }
      }

      return acc;
    }, [])
    .sort((a, b) => {
      if (!b.startDate) return 1;

      return a.startDate > b.startDate ? 1 : -1;
    });
}

export function hasRidesUnderMaintenance(rides) {
  return Boolean(parseRideMaintenanceSchedule(rides)?.length);
}
